import Content from './Content/index';

export const Home = () => {
  return <Content />;
};
